import lodash from "lodash";
import { defineAsyncComponent } from "vue";
import {
    createFieldInput,
    createFieldInputNumber,
    createFieldRadioGroup,
    createFieldSelect
} from "../../../../../components/input/template-builder/template-builder.logic";
import { createColumnInput, createColumnSelect } from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import store from "../../../../../store";
import { conditionFormChecker, putField } from "../../../../../utils/form";
import { createFieldDesc } from "../tab-1/tab1.section";
import { callUserRequestStatus, callUserRequestType } from "../tab-4/tab4.section";

const AttachmentInlineList = defineAsyncComponent(() => import("../../../../../components/attachment/AttachmentInlineList"));

export const callPayBy = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "PAY_BY", value: searchQuery });
export const callBank = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "BANK", value: searchQuery });
export const callBankType = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "BANK_TYPE", value: searchQuery });
export const callUserRequestDoc2Attachment = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "USER_REQUEST_DOC_2_ATTACHMENT", value: searchQuery });
export const callUserBankStatus = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "USER_BANK_STATUS", value: searchQuery });

export const createColumns = () => {
    return [
        createColumnSelect({
            title: () => i18n.global.t("model.userBank.refBank"),
            dataIndex: "refUserBankTemp.refBank.value",
            inputProp: () => ({ list: callBank, optLabel: "value" }),
            search: { name: "refUserBankTemp.refBank.id" }
        }),
        createColumnInput({ title: () => i18n.global.t("model.userBank.branch"), dataIndex: "refUserBankTemp.branch" }),
        createColumnSelect({
            title: () => i18n.global.t("model.userBank.refType"),
            dataIndex: "refUserBankTemp.refType.value",
            inputProp: () => ({ list: callBankType, optLabel: "value" }),
            search: { name: "refUserBankTemp.refType.id" }
        }),
        createColumnInput({ title: () => i18n.global.t("model.userBank.bankAccount"), dataIndex: "refUserBankTemp.bankAccount" }),
        createColumnInput({ title: () => i18n.global.t("model.userBank.bankName"), dataIndex: "refUserBankTemp.bankName" }),
        createColumnSelect({
            title: () => i18n.global.t("model.userRequest.refRequestType"),
            dataIndex: "refRequestType.value",
            inputProp: () => ({ list: callUserRequestType, optLabel: "value" }),
            search: { name: "refRequestType.id" },
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.userRequest.refStatus"),
            dataIndex: "refStatus.value",
            inputProp: () => ({ list: callUserRequestStatus, optLabel: "value" }),
            search: { name: "refStatus.id" },
            align: "center"
        })
    ];
};

export const createField = ({ props, data, key, isLoading }) => {
    const { viewOnly, menuContext } = props;
    //const { useForm } = data;
    //const { modelRef } = useForm;
    //const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            ...createFieldDesc({ props, data, key, isLoading }),
            ...createFieldUserBank({ props, data, key: `${prefix}refUserBankTemp`, isLoading }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnly,
                            dataProp: data,
                            itemsKey: `${prefix}refUserBankTemp.attachments`,
                            canCreate: !viewOnly,
                            canDelete: !viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "AttachmentInlineList" } })
                    );
                    return <AttachmentInlineList {...componentProp}></AttachmentInlineList>;
                }
            }
        ]
    });
};

export const createFieldUserBank = ({ props, data, key /*, isLoading */ }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refPayBy`,
                colProp: () => ({ xs: 24, md: 20 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 }}),
                label: () => i18n.global.t("model.userBank.refPayBy"),
                labelRender: () => " ",
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refPayBy,
                            "onUpdate:value": value => (model.refPayBy = value),
                            disabled: viewOnly,
                            list: callPayBy,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refBank`,
                colProp: () => ({ xs: 24, md: 20 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.userBank.refBank"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refBank,
                            "onUpdate:value": value => (model.refBank = value),
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callBank({ searchQuery }).then(data => data.filter(d => d.key === "006")),
                            // optLabel: "value"
                            renderLabel: ({ item }) => <div>{`${item.key} - ${item.value}`}</div>,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}branchCode`,
                colProp: () => ({ xs: 24, md: 20 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.userBank.branchCode"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.branchCode,
                            "onUpdate:value": value => (model.branchCode = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}branch`,
                colProp: () => ({ xs: 24, md: 20 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.userBank.branch"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.branch,
                            "onUpdate:value": value => (model.branch = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refType`,
                colProp: () => ({ xs: 24, md: 20 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.userBank.refType"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refType,
                            "onUpdate:value": value => (model.refType = value),
                            disabled: viewOnly,
                            list: callBankType,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}bankAccount`,
                colProp: () => ({ xs: 24, md: 20 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.userBank.bankAccount"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.bankAccount,
                            "onUpdate:value": value => (model.bankAccount = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}bankName`,
                colProp: () => ({ xs: 24, md: 20 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.userBank.bankName"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.bankName,
                            "onUpdate:value": value => (model.bankName = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}bankCust`,
                colProp: () => ({ xs: 24, md: 20 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.userBank.bankCust"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.bankCust,
                            "onUpdate:value": value => (model.bankCust = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}companyBranchCode`,
                colProp: () => ({ xs: 24, md: 10 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 17 }, wrapperCol: { xs: 24, md: 7 } }),
                label: () => i18n.global.t("model.userBank.companyBranchCode"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.companyBranchCode,
                            "onUpdate:value": value => {
                                model.companyBranchCode = value
                                console.log("companyBranchCode value", value)
                                if (value == 0) {
                                    model.companyBranchName = "สำนักงานใหญ่"
                                } else {
                                    model.companyBranchName = null;
                                }
                            },
                            disabled: viewOnly,
                            comma: false,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}companyBranchName`,
                colProp: () => ({ xs: 24, md: 14 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 7 }, wrapperCol: { xs: 24, md: 17 } }),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.companyBranchName,
                            "onUpdate:value": value => (model.companyBranchName = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
        ]
    });
};
